import { useEffect, useState } from 'react'
import { MenuItem, Select } from '@material-ui/core'
import { Box, TextField, Typography } from '@material-ui/core'
import { useTable, useSortBy } from 'react-table'
import './react-table.css'

let handleFilterTimeout = null

const CustomTable = ({
  data,
  page,
  pages,
  pageSize,
  sorted,
  filtered,
  columns,
  tableLoading,
  fetchData,
  filterProps,
  manualSortBy
}) => {
  const [inputPage, setInputPage] = useState(page)
  const [filters, setFilters] = useState(filterProps)

  useEffect(() => {
    if (page !== inputPage) {
      setInputPage(page)
    }
  }, [page])

  const { getTableProps, headerGroups, rows, prepareRow } = useTable(
    { columns, data, manualSortBy },
    useSortBy
  )

  const handleNext = () => {
    if (page < pages) {
      fetchData({
        page: page + 1,
        pageSize,
        sorted,
        filtered
      })
    }
  }

  const handlePrev = () => {
    if (page > 0) {
      fetchData({
        page: page - 1,
        pageSize,
        sorted,
        filtered
      })
    }
  }

  const handleGoToPage = () => {
    if (inputPage >= 0 && inputPage <= pages) {
      fetchData({
        page: inputPage,
        pageSize,
        sorted,
        filtered
      })
    }
  }

  const handleChangePageSize = (newPageSize) => {
    fetchData({
      page: 0,
      pageSize: newPageSize,
      sorted,
      filtered
    })
  }

  const handleFilter = (index, value) => {
    const newFilters = [...filters]
    newFilters[index].value = value
    setFilters(newFilters)
    clearTimeout(handleFilterTimeout)
    handleFilterTimeout = setTimeout(() => {
      const filtersSend = []
      newFilters.forEach((filter) => {
        if (filter.value && filter.value !== '') {
          filtersSend.push({
            id: filter.id,
            value: filter.value
          })
        }
      })
      fetchData({
        page: 0,
        pageSize,
        sorted,
        filtered: filtersSend
      })
    }, 1000)
  }

  const handleSort = (column) => {
    if (!column.sortable) return

    let isSortedDesc = undefined
    let sorted = []
    if (column.isSortedDesc === undefined) {
      isSortedDesc = false
      sorted = [
        {
          id: column.idSort || column.id,
          desc: isSortedDesc
        }
      ]
    } else if (column.isSortedDesc === false) {
      isSortedDesc = true
      sorted = [
        {
          id: column.idSort || column.id,
          desc: isSortedDesc
        }
      ]
    }

    column.toggleSortBy(isSortedDesc)

    if (!manualSortBy) return
    fetchData({
      page: 0,
      pageSize,
      sorted: sorted,
      filtered
    })
  }

  return (
    <div className="ReactTable -striped -highlight">
      {tableLoading && (
        <div className="-loading" style={{ zIndex: 999 }}>
          <div className="-loading-inner">Cargando...</div>
        </div>
      )}
      <div className="ReactTable rt-wrapper">
        <table {...getTableProps()} className="rt-table">
          <thead>
            {headerGroups.map((headerGroup, indexHeaderGroup) => (
              <tr
                key={`headerGroups-${indexHeaderGroup}`}
                {...headerGroup.getHeaderGroupProps()}
                className="rt-tr"
              >
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    onClick={() => handleSort(column)}
                    className="rt-th head"
                    style={{
                      maxWidth: column.Header === '' ? column.width : undefined
                    }}
                  >
                    {column.render('Header')}
                    <span>{column.isSorted ? (column.isSortedDesc ? ' ▼' : ' ▲') : ''}</span>
                  </th>
                ))}
              </tr>
            ))}
            <tr className="rt-tr" role="row">
              {filters.map((filter, index) => (
                <th
                  key={`filters-${index}`}
                  className="rt-th"
                  role="columnheader"
                  tabIndex="-1"
                  style={{
                    maxWidth: filter.maxWidth ? filter.maxWidth : undefined
                  }}
                >
                  {!!filter.id &&
                    (filter.options ? (
                      <Select
                        value={filter.value}
                        onChange={(ev) => handleFilter(index, ev.target.value)}
                        displayEmpty
                        style={{ width: '100%', minWidth: 140, textAlign: 'left' }}
                      >
                        <MenuItem value="" disabled>
                          {filter.placeholder}
                        </MenuItem>
                        {filter.options.map((filter, indexOption) => (
                          <MenuItem key={`options-${indexOption}`} value={filter.value}>
                            {filter.label}
                          </MenuItem>
                        ))}
                      </Select>
                    ) : (
                      <TextField
                        placeholder={filter.placeholder}
                        onChange={(ev) => handleFilter(index, ev.target.value)}
                        style={{ width: '100%', minWidth: 140 }}
                      />
                    ))}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!tableLoading &&
              rows.length !== 0 &&
              rows.map((row, index) => {
                prepareRow(row)
                return (
                  <tr
                    key={`rows-${index}`}
                    className={`rt-tr ${index % 2 === 0 ? '-odd' : '-even'}`}
                  >
                    {row.cells.map((cell, indexCell) => {
                      return (
                        <td
                          key={`cell-${indexCell}`}
                          style={{
                            width: cell.column.Header === '' ? cell.column.width : undefined
                          }}
                          {...cell.getCellProps()}
                          className="rt-td"
                        >
                          {cell.render('Cell')}
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
          </tbody>
        </table>
        {!tableLoading && rows.length === 0 && (
          <Box m={4}>
            <Typography align={'center'} color={'error'}>
              Sin resultados
            </Typography>
          </Box>
        )}
      </div>
      {pages > 1 && (
        <div className="pagination-bottom">
          <div className="-pagination">
            <div className="-previous">
              <button type="button" disabled={page + 1 <= 1} className="-btn" onClick={handlePrev}>
                Anterior
              </button>
            </div>
            <div className="-center">
              <span className="-pageInfo">
                Página{' '}
                <div className="-pageJump">
                  <input
                    type="number"
                    value={inputPage + 1}
                    onChange={(ev) => {
                      setInputPage(parseInt(ev.target.value) - 1)
                    }}
                    onBlur={handleGoToPage}
                  />
                </div>{' '}
                de <span className="-totalPages">{pages}</span>
              </span>
              <span className="select-wrap -pageSizeOptions">
                <select
                  value={pageSize}
                  onChange={(ev) => handleChangePageSize(parseInt(ev.target.value))}
                >
                  <option value="5">5 filas</option>
                  <option value="10">10 filas</option>
                  <option value="15">15 filas</option>
                  <option value="20">20 filas</option>
                  <option value="25">25 filas</option>
                  <option value="50">50 filas</option>
                  <option value="100">100 filas</option>
                </select>
              </span>
            </div>
            <div className="-next">
              <button
                type="button"
                className="-btn"
                onClick={handleNext}
                disabled={page + 1 >= pages}
              >
                Siguiente
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default CustomTable
